var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDeny(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Deny",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.66,
    height: 18.66,
    viewBox: "0 0 18.66 18.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_66670",
    "data-name": "Group 66670"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66668",
    "data-name": "Group 66668"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66667",
    "data-name": "Group 66667"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93659",
    "data-name": "Path 93659",
    d: "M9.33,1.749a7.58,7.58,0,1,1-7.58,7.58,7.589,7.589,0,0,1,7.58-7.58M9.33,0a9.33,9.33,0,1,0,9.33,9.33A9.33,9.33,0,0,0,9.33,0Z",
    fill: "#9c9faf"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_66669",
    "data-name": "Group 66669",
    transform: "translate(2.608 2.777)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93660",
    "data-name": "Path 93660",
    d: "M0,0H1.749V16.828H0Z",
    transform: "translate(11.898 0) rotate(45)",
    fill: "#9c9faf"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeny);
export default __webpack_public_path__ + "static/media/IconDeny.d17e1c45.svg";
export { ForwardRef as ReactComponent };